import { useState, useEffect } from 'react';
import NavbarView from './view';
import locale from './locale';
import { useTranslation } from 'react-i18next';
import { useMemberContext } from '@/shared/contexts/memberContext';
import useCurrentLanguage from '@shared/hooks/useCurrentLanguage';

const OUTSIDE_HOST = process.env.REACT_APP_VUE_CLIENT_URL;

const Navbar = () => {
    const [isAlreadyLogin, setIsAlreadyLogin] = useState(false);
    const { currentLang, toggleCurrentLanguage } = useCurrentLanguage();
    const { member } = useMemberContext();
    const { i18n } = useTranslation('navbar');
    i18n.addResourceBundle('en', 'navbar', locale.en);
    i18n.addResourceBundle('id', 'navbar', locale.id);

    useEffect(() => {
        if (member) {
            setIsAlreadyLogin(true);
        } else {
            setIsAlreadyLogin(false);
        }
    }, [member]);

    const handleLanguageSubMenuClicked = () => {
        toggleCurrentLanguage();
    };

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('member');
        localStorage.removeItem('memberActivated');
        localStorage.removeItem('lastLogin');
        localStorage.removeItem('LS_ROUTE_KEY');
        localStorage.removeItem('slang');
        window.location.href = `${OUTSIDE_HOST}/home?logout=yes`;
    };

    const handleShowSugesstionModal = () => {};

    return (
        <NavbarView
            currentLang={currentLang}
            isAlreadyLogin={isAlreadyLogin}
            onLogout={handleLogout}
            onShowSugesstionModal={handleShowSugesstionModal}
            onLanguageSubMenuClicked={handleLanguageSubMenuClicked}
        />
    );
};

export default Navbar;
